module.exports = __webpack_public_path__ + "static/GMDN-Pricing-2cf910f410c2c7974d24b38e3718b9c5.pdf";